import {useEventListener} from '@vueuse/core';

// 长按事件封装
export const useLongPress = (targetRef: HTMLElement, handler: (e: TouchEvent) => void, time: number) => {
  let timer: number | null;
  useEventListener(targetRef, 'touchstart', (e: TouchEvent) => {
    timer = null;
    timer = window.setTimeout(() => {
      handler(e);
      timer = null;
    }, time);
  });
  useEventListener(targetRef, 'touchmove', () => {
    clearTimeout(timer!);
    timer = null;
  });
  useEventListener(targetRef, 'touchend', () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  });
};
